<ll-titulo>Generar {{ nombreEvaluacion }}</ll-titulo>

<generar-ensayo-alumno
    [tipoEvaluacion]="tipoInstrumento"
    [generadorInstrumento]="generadorInstrumento"
></generar-ensayo-alumno>
